import {Show, Text} from 'platform/foundation';
import {useFormatCurrency} from 'platform/locale';

import type {MoneyTextProps} from '@dms/features/new-vehicle';

import {isNotNilOrEmpty, type Nullish} from 'shared/web';

import {t} from '../utils/catalogueUi';
import {grossOfNet} from '../utils/moneyInput';

/** The gross of a net price at the catalogue VAT rate; nothing without a rate or a valid price. */
export function GrossPriceText(props: {
  net: string;
  currency: string;
  vatRate: string | Nullish;
  align?: MoneyTextProps['align'];
}) {
  const formatCurrency = useFormatCurrency();
  const gross = isNotNilOrEmpty(props.vatRate) ? grossOfNet(props.net, props.vatRate) : undefined;
  return (
    <Show when={isNotNilOrEmpty(gross) ? gross : null}>
      {(amount) => (
        <Text size="xSmall" color="secondary" align={props.align}>
          {`${formatCurrency(Number(amount), props.currency, 2)} ${t('entity.newVehicle.labels.inclVat', 'incl. VAT')}`}
        </Text>
      )}
    </Show>
  );
}
